<template>
  <div class="w-full">
    <vs-alert title="Catatan" class="my-5">
      Menu <b>Konsep</b> merupakan list Konsep Surat Masuk yang sudah anda buat sebelumnya.
    </vs-alert>
    <div class="w-full flex justify-end">
      <div>
        <vs-input
          icon-pack="feather"
          icon="icon-search"
          placeholder="Cari"
          v-model="search"
        />
      </div>
    </div>
    <global-wrapper
      :loading="$apollo.queries.suratKonsep.loading"
      :loadingType="'OneLine'"
      :loadingList="5"
      :empty="suratKonsepModifier.length <= 0"
      :error="false"
    >
      <global-table
        @reloadData="handleOnReloadData($event)"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.totalPage"
      >
        <template #thead>
          <global-th width="20px">No.</global-th>
          <global-th>Nomor</global-th>
          <global-th>Asal Surat</global-th>
          <global-th>Perihal</global-th>
          <global-th>Tanggal</global-th>
          <global-th>Status</global-th>
          <global-th>Action</global-th>
        </template>
        <template #tbody>
          <global-tr
            v-for="(item, index) in suratKonsepModifier"
            :key="index"
          >
            <global-td>{{ item.number }}</global-td>
            <global-td>{{ item.nomor_surat.nomor }}</global-td>
            <global-td>{{ item.surat_masuk.pengirim }}</global-td>
            <global-td>{{ item.perihal }}</global-td>
            <global-td
              ><div class="whitespace-no-wrap">
                {{ item.tanggal | indonesian_date }}
              </div></global-td
            >
            <global-td><StatusChip :status="item.status"/></global-td>
            <global-td
              ><vs-button
                type="border"
                size="small"
                @click="clickedDetail(item.uuid)"
                >Detail</vs-button
              ></global-td
            >
          </global-tr>
        </template>
      </global-table>
    </global-wrapper>
  </div>
</template>

<script>
import _ from "lodash";
import StatusChip from "@/components/global/surat/StatusChip.vue";

import { GET_ALL_FILTER } from "@/query/surat";
import { STATUS_CONCEPT } from "../../../const/surat";

export default {
  components: {
    StatusChip
  },
  data() {
    return {
      skipQuerySurat: true,
      statusSurat: [STATUS_CONCEPT],
      pagination: {
        perPage: 10,
        totalPage: 0,
        currentPage: 1
      },
      search: ""
    };
  },
  apollo: {
    suratKonsep: {
      query() {
        return GET_ALL_FILTER;
      },
      update(data) {
        return this.suratKonsepData(data);
      },
      error() {
        this.error = true;
      },
      skip() {
        return this.skipQuerySurat;
      },
      fetchPolicy: "network"
    }
  },
  computed: {
    variables() {
      return {
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        orderBy: [
          {
            field: "TANGGAL",
            order: "DESC"
          }
        ],
        where: {
          AND: [
            {
              column: "STATUS",
              operator: "IN",
              value: this.statusSurat
            },
            {
              column: "DISPOSISI_TERAKHIR_PENGGUNA_ID",
              value: this.$user.id
            }
          ]
        },
        filter: {
          tipe: "surat_masuk",
          search: this.search
        }
      };
    },
    suratKonsepModifier() {
      if (typeof this.suratKonsep == "undefined") return [];

      const lastNumber = Math.ceil(
        this.pagination.perPage * (this.pagination.currentPage - 1)
      );
      
      let surat = this.suratKonsep.map((data, index) => {
        return { ...data, number: lastNumber + index + 1 };
      });

      let filteredSurat = surat.filter(data => {
        return data.status == 'konsep';
      });

      return filteredSurat;
    }
  },
  watch: {
    search() {
      this.refetchQuerySurat();
    }
  },
  mounted() {
    this.fetchQuerySurat();
  },
  methods: {
    suratKonsepData(data) {
      this.pagination.totalPage = data.surat.paginatorInfo.lastPage;
      return data.surat.data;
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.fetchQuerySurat();
    },
    refetchQuerySurat: _.debounce(function() {
      this.fetchQuerySurat();
    }, 300),
    fetchQuerySurat() {
      this.$nextTick().then(() => {
        this.error = false;
        this.skipQuerySurat = false;
        this.paginationPage = 1;
        this.$apollo.queries.suratKonsep.setVariables({ ...this.variables });
        this.$apollo.queries.suratKonsep.refetch();
      });
    },
    clickedDetail(uuid) {
      this.$router.push({
        name: "surat-masuk-detail",
        params: {
          uuid: uuid
        }
      });
    }
  }
};
</script>
